// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3VK42","inputWrap":"CustomTip_inputWrap__2O8sy"};